import React from "react";
import matrices from "./Matrices.pdf";

export default function Matrices() {
  return (
    <div>
      <iframe
        src={matrices}
        width="100%"
        className="h-screen"
        title="Matrices"
      />
    </div>
  );
}
